import {graphql} from '~/graphql-react-query';

export const ComplianceCreativeList = graphql(`
    query complianceCreativeList($input: ComplianceCreativeListQueryInput!) {
        compliance {
            creativeList(input: $input) {
                paginationInfo {
                    page
                    pageSize
                    hasNextPage
                }
                items {
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status
                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    aiDemographicsV1 {
                        genderDistribution {
                            unspecified
                            female
                            male
                        }
                        ageBracket
                        ageName
                    }
                    aiSummaryInsightsV1 {
                        summary150
                        summary300
                    }
                    aiTagsV1 {
                        advertiser
                        industry
                        category
                        product
                    }
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_ranking
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const ComplianceCsv = graphql(`
    query ComplianceCsv($input: ComplianceCsvInput!) {
        compliance {
            csv(input: $input) {
                csv
                errorJson
            }
        }
    }
`);

export const ComplianceShortlists = graphql(`
    query ComplianceShortlists($input: ComplianceShortlistsQueryInput!) {
        compliance {
            shortlists(input: $input)
        }
    }
`);

export const ComplianceShortlistCreatives = graphql(`
    query ComplianceShortlistCreatives($shortlist: String!, $complianceCodeId: String!) {
        compliance {
            creatives(input: {shortlist: $shortlist, complianceCodeId: $complianceCodeId}) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
                creative {
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status
                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_ranking
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const ComplianceShortlistCreative = graphql(`
    query ComplianceShortlistCreative($complianceCodeId: String!, $creativeId: String!) {
        compliance {
            creative(input: {complianceCodeId: $complianceCodeId, creativeId: $creativeId}) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
                creative {
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status
                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_ranking
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const ComplianceAddToShortlist = graphql(`
    mutation ComplianceAddToShortlist($input: ComplianceFavoritesMutationInput!) {
        compliance {
            addToShortlist(input: $input) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
                creative {
                    id
                    creative
                }
            }
        }
    }
`);

export const ComplianceRemoveFromShortlist = graphql(`
    mutation ComplianceRemoveFromShortlist($input: ComplianceFavoritesMutationInput!) {
        compliance {
            removeFromShortlist(input: $input) {
                creativeId
                teamId
                complianceCodeId
                progressStatus
                notes
                shortlists
                history {
                    summary
                    actor
                    timestamp
                }
                createdAt
                createdBy
                updatedAt
                updatedBy
                creative {
                    id
                    creative
                }
            }
        }
    }
`);
